var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data.karriereSeiteData)?_c('page',{key:_vm.data.karriereSeiteData.id,attrs:{"data":_vm.data.karriereSeiteData,"breakBlockData":_vm.data.breakBlockData,"newDesign":_vm.data.karriereSeiteData.attributes.new_design}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }